import type { Envelope, Slot } from '$lib/types/public-resources/launches/launch';
import { gramsToKilograms } from '../../utils/unitConversion';

export function generateEmailMessage(
  availableCapacity: { slots: Slot[] },
  requestedSlots: Array<number>,
  requestedServices: Set<string>,
  idLaunch: string
): string {
  let message = `Launch id: ${idLaunch}\n\n`;
  message += formatRequestedSlots(availableCapacity, requestedSlots);

  message += formatRequestedServices(requestedServices);

  return message;
}

function formatRequestedSlots(availableCapacity: { slots: Slot[] }, requestedSlots: Array<number>) {
  let slotMessage = 'Requested slot(s): \n';

  for (let index = 0; index < availableCapacity.slots.length; index++) {
    if (requestedSlots[index] > 0) {
      let slot = availableCapacity.slots[index];
      if (slot.capacity !== null) {
        slotMessage += ` - ${requestedSlots[index]} * ${gramsToKilograms(slot.capacity)} kg`;
      } else {
        slotMessage += ` - ${requestedSlots[index]}`;
      }

      if (slot.envelope) {
        slotMessage += ` (${slot.envelope.length} x ${slot.envelope.width} x ${slot.envelope.height})`;
      }

      slotMessage += `\n`;
    }
  }

  return slotMessage;
}

function formatRequestedServices(requestedServices: Set<string>) {
  let servicesMessage = 'Requested Service(s): \n';

  if (requestedServices.size > 0) {
    requestedServices.forEach((service) => {
      servicesMessage += ` - ${service} \n`;
    });
  } else {
    servicesMessage += ' - no service selected';
  }

  return servicesMessage;
}

export function generateRecapMessage(
  availableCapacity: { slots: Slot[] },
  requestedSlots: Array<number>
) {
  let message = '';
  for (let index = 0; index < availableCapacity.slots.length; index++) {
    if (requestedSlots[index] > 0) {
      let slot = availableCapacity.slots[index];

      message += formatSlotQuantity(requestedSlots[index]);

      message += formatSlotCapacity(slot.capacity);

      if (slot.capacity !== null && slot.envelope) {
        message += ' and';
      }

      message += formatEnvelope(slot.envelope);

      message += '\n';
    }
  }
  return message;
}

function formatSlotQuantity(quantity: number): string {
  return quantity > 1 ? ` • ${quantity} slots,` : ' • 1 slot,';
}

function formatSlotCapacity(capacity: number | null) {
  return capacity !== null ? ` up to ${gramsToKilograms(capacity)} kg` : '';
}

function formatEnvelope(envelope: Envelope | null) {
  return envelope
    ? ` ${envelope.length} x ${envelope.width} x ${envelope.height} (L x W x H in cm)`
    : '';
}
